import React from "react";
import "./Skeleton.css";

/**
 * The one loading bar: muted, shimmering, still under `prefers-reduced-motion`.
 * Width is the caller's, as a CSS length, so a column of bars can vary.
 */
export const Skeleton: React.FC<{ width?: string; className?: string }> = ({
  width = "60%",
  className = "",
}) => (
  <span
    className={`skeleton ${className}`}
    style={{ width }}
    aria-hidden="true"
    data-testid="skeleton"
  />
);
